import { render, staticRenderFns } from "./confirm-action.vue?vue&type=template&id=e8fbdaf0&scoped=true"
import script from "./confirm-action.vue?vue&type=script&lang=js"
export * from "./confirm-action.vue?vue&type=script&lang=js"
import style0 from "./confirm-action.vue?vue&type=style&index=0&id=e8fbdaf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8fbdaf0",
  null
  
)

export default component.exports